<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="stockTransferItems"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :stockTransfer="stockTransfer"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" >
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
        :stockTransfer="stockTransfer"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :stockTransfer="stockTransfer"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      tableHeaders: [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        { text: "Quantidade Transferida", align: "left", sortable: true, value: "quantity" },
        { text: "Unidade", align: "left", sortable: true, value: "item.unit.name" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        { field: 'quantity', mask: 'number' },
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    stockTransferItems: { 
      type: Array,
      default: () => []
    },
    stockTransfer: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Item de Transferência entre Estoques"
    },
    modelNamePlural: {
      type: String,
      default: "Itens de Transferência entre Estoques"
    },
  },
  created() {
  },
  methods: {
    entryUpdated: function(editedEntry){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(editedEntry){
      this.stockTransferItems.push(editedEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(editedEntry){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
  }
};
</script>

<style scoped></style>
